import React, { useState, useEffect } from 'react';
import Teams from '../TeamsEnum';
import DatePicker from "react-datepicker";

const Torneos = {
  LIGA_PROFESIONAL: "Liga Profesional Argentina",
  COPA_ARGENTINA: "Copa Argentina",
  COPA_SUDAMERICANA: "Copa Sudamericana",
  COPA_LIBERTADORES: "Copa Libertadores",
};

const NextAwayMatchTable = ({ nextAwayMatches, onDelete, onEdit }) => {
  const [sortedMatches, setSortedMatches] = useState([]);
  const [sortAsc, setSortAsc] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedMatchId, setSelectedMatchId] = useState(null);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const sorted = [...nextAwayMatches].sort((a, b) =>
      sortAsc ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date)
    );
    setSortedMatches(sorted);
  }, [nextAwayMatches, sortAsc]);

  const [formData, setFormData] = useState({
    id: '',
    date: '',
    matchHours: '',
    placeName: '',
    placeAddress: '',
    vsTeam: '',
    torneo: '',
  });

  const handleDeleteClick = (id) => {
    setSelectedMatchId(id);
    setShowDialog(true);
  };

  const confirmDelete = () => {
    onDelete(selectedMatchId);
    setShowDialog(false);
  };

  const cancelDelete = () => {
    setShowDialog(false);
  };

  const handleEditClick = (match) => {
    setFormData({ ...match });
    setEditMode(true);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (event) => {
    event.preventDefault();
    await onEdit(formData);
    setEditMode(false);
  };

  return (
    <>
      {/* Table */}
      {!editMode ? (
        <table className="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th>Torneo</th>
              <th>Versus</th>
              <th
                onClick={() => setSortAsc(!sortAsc)}
                style={{ cursor: 'pointer', userSelect: 'none' }}>
                Fecha {sortAsc ? '↑' : '↓'}
              </th>
              <th>Hora</th>
              <th>Lugar</th>
              <th>Dirección</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedMatches.map((match) => (
              <tr key={match.id}>
                <td>{match.torneo}</td>
                <td>{match.vsTeam}</td>
                <td>{match.date}</td>
                <td>{match.matchHours}</td>
                <td>{match.placeName}</td>
                <td>{match.placeAddress}</td>
                <td>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={() => handleEditClick(match)}
                      className="btn btn-warning"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => handleDeleteClick(match.id)}
                      className="btn btn-danger"
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (

        /* Edit form */
        <div className="edit-form">
          <h3>Editar Partido de Visitante</h3>
          <form onSubmit={handleEditSubmit}>

            <div className="form-group">
              <label htmlFor="torneo" className="form-label">Torneo</label>
              <select
                className="form-control"
                id="torneo"
                name="torneo"
                onChange={handleInputChange}
                value={formData.torneo}>
                <option value="" disabled>Seleccionar torneo</option>
                {Object.entries(Torneos).map(([key, value]) => (
                  <option key={key} value={value}>{value}</option>
                ))}
              </select>
            </div>

            <div style={{ height: '20px' }}></div>

            <div className="form-group">
              <label htmlFor="vsTeam" className="form-label">Versus</label>
              <select
                className="form-control"
                id="vsTeam"
                name="vsTeam"
                onChange={handleInputChange}
                value={formData.vsTeam}>
                <option value="" disabled>Seleccionar equipo</option>
                {Object.entries(Teams).map(([key, value]) => (
                  <option key={key} value={value}>{value}</option>
                ))}
              </select>
            </div>

            <div style={{ height: '20px' }}></div>

            <div className="form-group">
              <label htmlFor="date" className="form-label">Fecha</label>
              <DatePicker
                selected={(() => {
                  if (!formData.date) return null;
                  // Handle dd-MM-yyyy format
                  const parts = formData.date.split('-');
                  if (parts.length === 3 && parts[0].length <= 2) {
                    return new Date(parts[2], parts[1] - 1, parts[0]);
                  }
                  const d = new Date(formData.date);
                  return isNaN(d.getTime()) ? null : d;
                })()}
                className="form-control"
                id="date"
                name="date"
                dateFormat="dd-MM-yyyy"
                onChange={(date) => {
                  if (!date) return;
                  const dd = String(date.getDate()).padStart(2, '0');
                  const mm = String(date.getMonth() + 1).padStart(2, '0');
                  const yyyy = date.getFullYear();
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    date: `${dd}-${mm}-${yyyy}`,
                  }));
                }}
              />
            </div>

            <div style={{ height: '20px' }}></div>

            <div className="mb-3">
              <label htmlFor="matchHours" className="form-label">Hora Partido</label>
              <input
                type="time"
                className="form-control"
                id="matchHours"
                name="matchHours"
                onChange={handleInputChange}
                value={formData.matchHours}
              />
            </div>

            <div style={{ height: '20px' }}></div>

            <div className="form-group">
              <label>Lugar (nombre)</label>
              <input
                type="text"
                name="placeName"
                value={formData.placeName}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>

            <div style={{ height: '20px' }}></div>

            <div className="form-group">
              <label>Lugar (dirección)</label>
              <input
                type="text"
                name="placeAddress"
                value={formData.placeAddress}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>

            <div style={{ height: '20px' }}></div>

            <button
              type="submit"
              style={{ backgroundColor: '#C73B33', borderColor: '#FF5733', color: '#FFF' }}
              className="btn">
              Guardar Cambios
            </button>

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={() => setEditMode(false)}>
              Cancelar
            </button>

            <div style={{ height: '80px' }}></div>

          </form>
        </div>
      )}

      {/* Delete confirmation dialog */}
      {showDialog && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h4>Estas seguro?</h4>
            <p>Una vez borrado no se puede recuperar</p>
            <div className="modal-footer">
              <button onClick={confirmDelete} className="btn btn-danger">
                OK
              </button>
              <button onClick={cancelDelete} className="btn btn-secondary">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const modalStyles = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyles = {
  backgroundColor: 'white',
  padding: '50px',
  borderRadius: '5px',
  textAlign: 'center',
};

export default NextAwayMatchTable;
